<template>
  <div class="new-quote">
    <div class="header">
      <div class="title">Nueva Cotización</div>
      <div class="close close-desktop" @click="close">
        Cerrar
        <img class="cross-icon" src="/cross.svg">
      </div>
      <div class="close close-mobile" @click="$router.push('/home')">
        Cerrar
        <img class="cross-icon" src="/cross.svg">
      </div>
    </div>
    <form class="form">
      <div class="type-selection">
        <div
          class="type-button"
          :class="{ 'type-selected': floorType === 1 }"
          @click="() => { floorType = 1 }">
          Cerámico
        </div>
        <div
          class="type-button"
          :class="{ 'type-selected': floorType === 2 }"
          @click="() => { floorType = 2 }">
          Porcelanato
        </div>
      </div>
      <div class="price-calculator">
        <label for="meters" class="input-label meters-label">
          Cantidad metros:
          <input type="text" class="input" id="meters" v-model="meters">
        </label>
        <label  class="input-label price-label">
          Costo aproximado:
          <div class="price-value">
            ${{ priceEstimate }}
          </div>
        </label>
      </div>
      <label for="full-name" class="input-label">
        Fecha de visita:
        <datetime class="input" v-model="date" type="datetime" :minute-step="15"></datetime>
      </label>
      <label for="full-name" class="input-label">
        Nombre completo del cliente:
        <input type="text" class="input" id="full-name" v-model="fullName">
      </label>
      <label for="phone-number" class="input-label">
        Teléfono:
        <input type="text" class="input" id="phone-number" v-model="phoneNumber">
      </label>
      <label for="address" class="input-label">
        Dirección:
        <input type="text" class="input" id="address" v-model="address">
      </label>
      <label for="city" class="input-label">
        Alcaldia/Delegación:
        <input type="text" class="input" id="city" v-model="city">
      </label>
      <label for="postal-code" class="input-label">
        Codigo Postal:
        <input type="text" class="input" id="postal-code" v-model="postalCode">
      </label>
      <label class="input-label">
        Referencias:
        <textarea class="textarea" v-model="references"></textarea>
      </label>
      <div class="button" @click="newQuote">Agendar</div>
    </form>
  </div>
</template>

<script>
import 'vue-datetime/dist/vue-datetime.css';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { Datetime } from 'vue-datetime';
import { Settings } from 'luxon';

Settings.defaultLocale = 'es';
// You need a specific loader for CSS files

const { mapActions } = createNamespacedHelpers('quote');
export default {
  data() {
    return {
      fullName: '',
      phoneNumber: '',
      address: '',
      city: '',
      state: '',
      postalCode: '',
      references: '',
      floorType: 0,
      meters: 0,
      date: moment().toISOString(),
      moment,
    };
  },
  components: {
    Datetime,
  },
  computed: {
    priceEstimate() {
      if (this.floorType === 1 && this.meters !== 0) {
        const floorPrice = 134.99;
        return (parseFloat(this.meters) * floorPrice).toFixed(2);
      }
      if (this.floorType === 2 && this.meters !== 0) {
        const floorPrice = 159.99;
        return (parseFloat(this.meters) * floorPrice).toFixed(2);
      }
      return '0';
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    newQuote() {
      this.createQuote({
        id: this.user.id,
        data: {
          quote_date: this.moment(this.date).format('YYYY-MM-DD HH:MM:SS'),
          quote_value: this.priceEstimate,
          full_name: this.fullName,
          phone_number: this.phoneNumber,
          address: this.address,
          city: this.city,
          postal_code: this.postalCode,
          references: this.references,
        },
      }).then(() => {
        this.$router.push('/home');
      });
    },
    close() {
      this.$emit('close');
    },
    ...mapActions([
      'createQuote',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.new-quote {
  width: 100%;
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
  height: fit-content;
  margin-bottom: 20px;
}
.title {
  font-size: 20px;
}
.input-label {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
}
.input {
  color: #5f6368;
  margin-top: 10px;
  border: 1px solid #DCDEDD;
  border-radius: 4px;
  padding: 6px;

  &:focus {
    border: 1px solid #f79916;
  }
}
.textarea {
  height: 82px;
  font-family: inherit;
  border: 1px solid #DCDEDD;
  resize: none;
  padding: 6px;
  color: #5f6368;
}
.button {
  background-image: linear-gradient(to right, #f6d365 0%, #f79916 51%, #f6d365 100%);
  display: flex;
  justify-content: center;
  padding: 14px;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
.type-selection {
  display: flex;
  justify-content: space-around;
}
.type-button {
  margin-top: 16px;
  width: 40%;
  padding: 10px 0;
  border: 1px solid #DCDEDD;
  display: flex;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
}
.type-selected {
  background-color: #f79916;
  color: white;
}
.price-calculator {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
}
.meters-label {
  width: 40%;
}
.price-value {
  font-size: 24px;
  margin-top: 4px;
}
.price-label {
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  img {
    height: 14px;
    width: auto;
    margin-left: 8px;
  }
}
.close {
  display: flex;
  align-items: center;
  color: #f79916;
  cursor: pointer;
}
.close-mobile {
  display: none;
}

@media only screen and (max-width: 600px) {
  .price-calculator {
    flex-direction: column;
  }
  .meters-label {
    width: 100%;
  }
  .price-label {
    width: 100%;
  }
  .close-desktop {
    display: none;
  }
  .close-mobile {
    display: flex;
  }
}
</style>
